<template>
  <ListItem
    tag="button"
    :item="item"
    :class="{ revealed: isCollapsed }"
    @click="toggleCollapse"
  >
    <template #icon>
      <div class="collapse-icon" />
    </template>
    <template #after>
      <SmoothReflow class="collapse">
        <div v-if="isCollapsed" class="collapse__container">
          <div class="collapse__content" v-html="nbsp(item.content)" />
        </div>
      </SmoothReflow>
    </template>
  </ListItem>
</template>

<script lang="ts" setup>
import { useThrottleFn } from '@vueuse/core'

defineProps<{
  item: { label: string; content: string }
}>()

const isCollapsed = ref(false)

const toggleCollapse = useThrottleFn(() => {
  isCollapsed.value = !isCollapsed.value
}, 600)
</script>

<style lang="scss" scoped>
.collapse-icon {
  $thickness: rem(2px);
  @include size(rem(13px));
  @include center-content;
  position: relative;

  @include media-up(lg) {
    @include size(rem(17px));
  }

  &::before,
  &::after {
    position: absolute;
    content: '';
    background: currentColor;
  }

  &::before {
    width: $thickness;
    height: 100%;
    transition: transform $transition-slow;

    .revealed & {
      transform: rotate(90deg);
    }
  }

  &::after {
    width: 100%;
    height: $thickness;
  }
}

@keyframes collapse-content {
  from {
    opacity: 0;
    transform: translateY(-200%);
  }

  50% {
    opacity: 0;
    transform: translateY(-100%);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.collapse {
  width: 100%;
  max-width: rem(500px);

  @include media-up(lg) {
    max-width: rem(620px);
  }

  &__container {
    margin-top: rem(26px);
    overflow: hidden;

    @include media-up(md) {
      margin-top: rem(19px);
    }
  }

  &__content {
    @include wysiwyg;
    animation: collapse-content 0.6s ease-out;
  }
}
</style>
